import React from 'react';

const Loading = () => (
  <div className="loading">
    <div className="spinner"></div>
  </div>
);

export default Loading;
